<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="page-list flex flex-direction">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                row-key="id"
                style="width: 100%">
                <el-table-column label="任务名称" prop="name">
                    <template slot-scope="scope">
                        {{ scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column label="进度" prop="level" width="170">
                    <template slot-scope="scope">
                        <div class="flex align-center justify-center">
                            <div :class="scope.row.state | state_color" class="task-tag radius">
                                {{ scope.row.state | state(scope.row.is_change)}}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="优先级" prop="level" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <el-tag :type="scope.row.level | level_color" class=" radius">{{ scope.row.level | level}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="分值" prop="p_mid" width="100">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.score || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" prop="p_mid" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.member_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="完成时间" prop="end_time" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.end_time }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="end_time" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <el-button class="radius" type="primary" @click="addTask(scope.row)">
                                审核
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <task-review-dialog :dialog-visible="addTaskDetailDialog" :pname="pname" :tid="cur_task_id"  @watchState="watchState"></task-review-dialog>
    </div>
</template>

<script>

import {getExTaskReviewList, getProjectStatus} from "@/api";
import {level_color, levels, task_color, task_state} from "@/utils/const";
import TaskReviewDialog from "@/views/web/principal/components/TaskReviewDialog";

export default {
    name: "task-review",
    components: {TaskReviewDialog},
    data() {
        return {
            pid: 0,
            pname: '',
            lists: [],
            loading: false,
            cur_task_id: 0,
            cur_sid: 0,
            addTaskDetailDialog: false,
            readonly: false,//是否显示分值
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.pname = this.$route.params.title
        this.$emit('setIndex', [1,3], `${this.pname} 任务评审`, true)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _data = await getProjectStatus(this.pid)
            this.readonly = _data.data.is_operation === 0
            this.getTaskList()
        },
        async getTaskList() {
            this.loading = true
            let _data = await getExTaskReviewList(this.pid)
            this.lists = _data.data
            this.loading = false

        },
        addTask(data) {
            this.cur_task_id = data.id
            this.addTaskDetailDialog = true
        },
        watchState(data) {
            if (data) {
                this.getTaskList()
            }
            this.cur_task_id = 0
            this.addTaskDetailDialog = false
        }

    },
    filters: {
        //1赋分审核中 2赋分审核通过（进行中） 3赋分驳回 4修改任务审核中 5修改任务驳回 6任务评审审核中 7任务完成 8逾期 9任务评审驳回
        state(val, is_change) { //任务状态
            return task_state(val, is_change)
        },
        state_color(val) {//任务状态颜色
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return task_color(val)
        },
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .menus {
        width: 210px;
        border-radius: 0 20px 20px 0;
        background: #0a2240;

        .menu-item {
            width: 100%;
            height: 85px;
            background: none;
            position: relative;

            &.active, &:hover {
                background-color: #011733;
                border-radius: 4px;
                cursor: pointer;
            }

            &.active {
                &:before {
                    position: absolute;
                    right: -8px;
                    border-top: 8px solid transparent;
                    border-left: 8px solid #233953;
                    border-bottom: 8px solid transparent;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }

            .title {
                font-size: 16px;
                color: var(--white);

                &.active {
                    color: var(--orange);

                }
            }

            i {
                font-size: 12px;
                color: var(--white);

                &.max {
                    font-size: 16px;
                    transform: rotate(90deg);
                    cursor: pointer;
                }

                &.active {
                    color: var(--orange);
                }
            }
        }
    }
}
</style>
